export const isSamsung = (userAgent) => {
  const supportedGalaxyModels = /(SM-(G9[3-9]|N[89][5-9]|T[89][0-9]|)[0-9]|SC-0[1-3]|SCV[34][0-9])/;
  return supportedGalaxyModels.test(userAgent);
};
